import { motion } from "framer-motion";

// The crossed-circle / eye emblem from the brand mark.
export const Emblem = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1" />
    <line x1="20" y1="2" x2="20" y2="38" stroke="currentColor" strokeWidth="1" />
    <circle cx="20" cy="20" r="4" fill="var(--noir-crimson)" />
  </svg>
);

export const RevealText = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 34 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "" }) => (
  <span
    className={`font-mono-accent text-[10px] md:text-xs uppercase tracking-[0.32em] text-white/40 ${className}`}
  >
    {children}
  </span>
);
